<template>
  <div class="event-main">
    <EventButtonNew/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-event">
          イベント名
        </div>

        <div class="table-header-place">
          開催地
        </div>

        <div class="table-header-datetime">
          開催日時
        </div>

        <div class="table-header-timezone">
          タイムゾーン
        </div>

        <div class="table-header-closetime">
          回答時間
        </div>

        <div class="table-header-entries">
          承認者 / 参加者
        </div>

        <div class="table-header-action">
          アクション
        </div>
      </div>

      <div
        v-for="(event, index) in events"
        :key="index"
        @click="editEvent(event)"
        v-bind:class="{ 'table-cell': true, 'auto-entry': event.get('autoEntry') }"
        >

        <div class="table-cell-event">
          {{ event.get('name') }}
        </div>

        <div class="table-cell-place">
          {{ event.get('place') }}
        </div>

        <div class="table-cell-datetime">
          {{ datetime(event) }}
        </div>

        <div class="table-cell-timezone">
          {{ event.get('timezone') }}
        </div>

        <div class="table-cell-closetime">
          {{ event.get('closeTime') }} 分
        </div>

        <div class="table-cell-entries">
          {{ entries(event) }}
        </div>

        <div class="table-cell-action">
          <div class="icons">
            <icon-quizset :event="event" />
            <icon-entry :event="event" />
            <icon-close :event="event" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import EventButtonNew from '@/components/Event/ButtonNew'
import IconQuizset from '@/components/Event/IconQuizset'
import IconEntry from '@/components/Event/IconEntry'
import IconClose from '@/components/Event/IconClose'

export default {
  components: {
    EventButtonNew,
    IconQuizset,
    IconEntry,
    IconClose
  },

  computed: {
    ...mapState('event', [
      'events'
    ])
  },

  created: async function () {
    await this.$store.dispatch('event/getEntries')
  },

  methods: {
    editEvent: function (event) {
      this.$router.push({
        name: 'event-edit',
        params: { id: event.id }
      })
    },

    datetime: function (event) {
      let text = [
        format(event.get('date'), 'M月D日'),
        ' ',
        event.get('start'),
        ' - ',
        event.get('finish'),
      ].join('')
      return text
    },

    entries: function (event) {
      let entries = this.$store.state.event.entries
      if (entries[event.id]) {
        let total = entries[event.id].length
        let joins = entries[event.id].filter((entry) => {
          return entry.get('allowed').get('name') == 'allowed'
        }).length
        return `${joins} / ${total}`
      } else {
        return '登録なし'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.event-main {
  .auto-entry {
    background-color: orange;
  }
}

@mixin cell {
  &-event {
    padding: 5px;
    width: 25%;
  }

  &-place {
    padding: 5px;
    width: 10%;
  }

  &-datetime {
    padding: 5px;
    width: 20%;
  }

  &-timezone {
    padding: 5px;
    width: 10%;
  }

  &-closetime {
    padding: 5px;
    width: 10%;
  }

  &-entries {
    padding: 5px;
    width: 10%;
  }

  &-action {
    padding: 5px;
    width: 15%;
  }
}

@import '@/styles/_table.scss';
@import '@/styles/_icon.scss';
</style>
